import Viewer from "./Viewer"
import Editor from "./Editor"

export default {
    name: "activityVr",
    title: "Activity VR",
    icon: require("./content-icon.svg"),
    category: "training",
    Viewer,
    Editor,
    Preview: Viewer
}